import React from "react";
import { SLUG_TO_PUBTYPE_MAP } from "../../../constants/pubType";
import TopicName from "./TopicName";
import PubTypeLine from "./PubTypeLine";
import AdditionalItems from "./AdditionalItems";
import ChemoRegimenMetadata from "./ChemoRegimenMetadata";
import ContentGroups from "./ContentGroups";
import {
  StyledHeader,
  StyledTitleHolder,
  StyledLogo,
  StyledContributors,
} from "./_.styled";

const EMPTY_LIST = [];

const TopicHeader = ({
  togglePlay,
  slugPubType,
  prettyPubtype,
  title: { pronunciation, testId: pubtypeTestId, icon },
  tags,
  additionalMetadata = EMPTY_LIST,
  isMobile,
  isDesktop,
  pubTypeLogos,
  otherLanguages,
  classes,
  routes,
  howToSayIt,
  pageHeading,
  hasAudio,
  onTopicUpdatesLinkClick,
  createdAt,
  updatedAt,
  drugInteractionEvent,
  telemetryData,
  isPreviewMode,
  openWithCloudinaryToken,
  pdfFiles,
  cinahlRedirectionLink,
  crossContentReferenceLinks,
  chemoRegimenMetadata,
  boxedWarnings,
  boxedWarningProps,
  contributors,
  isContributorNamesDialogEnabled,
  contributorLogos,
  isCMELinkVisible,
  productName,
}) => {
  const logo = pubTypeLogos?.[SLUG_TO_PUBTYPE_MAP[slugPubType]];
  const shouldShowMobileLogo = !!(logo && isMobile);

  return (
    <StyledHeader data-testid="topic-header">
      <StyledTitleHolder>
        {shouldShowMobileLogo && (
          <StyledLogo
            data-testid="content-mobile-drug-logo"
            src={logo.src}
            alt={logo.alt}
          />
        )}
        {prettyPubtype && (
          <PubTypeLine
            prettyPubtype={prettyPubtype}
            pubtypeTestId={pubtypeTestId}
            createdAt={createdAt}
            updatedAt={updatedAt}
            onTopicUpdatesLinkClick={onTopicUpdatesLinkClick}
            chemoRegimenPubTypeMetadata={chemoRegimenMetadata?.pubType}
            cinahlRedirectionLink={cinahlRedirectionLink}
            isCMELinkVisible={isCMELinkVisible}
            productName={productName}
          />
        )}

        <TopicName
          icon={icon}
          pageHeading={pageHeading}
          pronunciation={pronunciation}
          hasAudio={hasAudio}
          togglePlay={togglePlay}
          tags={tags}
          logo={logo}
          boxedWarnings={boxedWarnings}
          boxedWarningProps={boxedWarningProps}
        />

        <AdditionalItems
          drugInteractionEvent={drugInteractionEvent}
          howToSayIt={howToSayIt}
          isDesktop={isDesktop}
          isMobile={isMobile}
          isPreviewMode={isPreviewMode}
          telemetryData={telemetryData}
          prettyPubtype={prettyPubtype}
          pdfFiles={pdfFiles}
          crossContentReferenceLinks={crossContentReferenceLinks}
          openWithCloudinaryToken={openWithCloudinaryToken}
          otherLanguages={otherLanguages}
          classes={classes}
          routes={routes}
        />

        <ChemoRegimenMetadata metadata={chemoRegimenMetadata} />
        <ContentGroups additionalMetadata={additionalMetadata} />

        {isContributorNamesDialogEnabled && (
          <StyledContributors
            contributors={contributors ?? EMPTY_LIST}
            contributorLogos={contributorLogos ?? EMPTY_LIST}
          />
        )}
      </StyledTitleHolder>
    </StyledHeader>
  );
};

TopicHeader.displayName = "TopicHeader";
export default TopicHeader;
